function AlertBar() {
	const alertContainer = document.getElementById('e29-alert-bar');
	const alertItem = alertContainer
		? alertContainer.querySelector('.alert-bar__item')
		: false;
	const currentStorage = JSON.parse(sessionStorage.getItem('e29-alert-bar'));
	const alertState = currentStorage ? currentStorage : {};

	//Manage viewed state
	function setStorage() {
		sessionStorage.setItem('e29-alert-bar', JSON.stringify(alertState));
	}

	if (alertItem) {
		const alertClose = alertItem.querySelector('.alert-bar__close');
		const alertID = alertItem.getAttribute('id');

		//Loop through local storage and determine what has been viewed
		if (currentStorage) {
			for (const item in currentStorage) {
				if (item === alertID && currentStorage[item].viewed) {
					alertContainer.classList.add('viewed');
					alertContainer.style.display = 'none';
				}
				if (item === alertID && !currentStorage[item].viewed) {
					alertContainer.classList.remove('viewed');
					alertContainer.style.display = 'block';
				}
			}
		}

		//No local storage, set all to not viewed
		else {
			alertState[alertID] = { viewed: false };
			alertContainer.classList.remove('viewed');
			alertContainer.style.display = 'block';
		}

		//Close alert item and set local storage
		if (alertClose) {
			alertClose.addEventListener('click', function (e) {
				e.preventDefault();
				alertContainer.classList.add('viewed');
				alertContainer.style.display = 'none';
				alertState[alertID] = { viewed: true };
				setStorage();
			});
		}

		//Create local storage if it doesn't exist
		if (!currentStorage) {
			setStorage();
		}
	}
}

export default AlertBar;
